'use client';

import React, { FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { usePromoCheck } from '@/src/hooks/usePromo';
import { getGenerationType, PromoItem } from '@/src/utils/getGenerationType';

interface PromoLabelProps {
  item: PromoItem;
  className?: string;
}

const styles = {
  tag: 'absolute top-1 right-1',
  freeLabel: 'w-[42px] h-[23px] bg-gradient-to-r from-orange-500 to-amber-400 rounded-[11.5px] flex items-center justify-center text-[11px] font-bold text-white shadow-sm',
};

export const PromoLabel: FC<PromoLabelProps> = ({ item, className }) => {
  // Определяем тип генерации для проверки промо
  const generationType = useMemo(() => getGenerationType(item), [item]);

  const { promoCheck } = usePromoCheck(generationType);

  // Показываем лейбл FREE если есть активная промо-акция
  if (promoCheck.isFree && generationType) {
    return (
      <div className={twMerge(className || styles.tag, styles.freeLabel)}>
        FREE
      </div>
    );
  }

  return null;
};
